<app-modal
  [title]="(isWithdraw ? 'Auszahlungsbetrag wählen' : 'Choose card amount') | trans:(isWithdraw ? 'cards/card-amount-picker-modal/header/titleWithdraw' : 'cards/card-amount-picker-modal/header/title')"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      @if (card) {
        <div class="text-center m-b-16">
          <p class="text-lg m-b-8">
            @if (isWithdraw) {
              {{ 'Wählen Sie den Auszahlungsbetrag für die Karte mit der Nummer:' | trans:'cards/card-amount-picker-modal/card-number-withdraw.Label' }}
            } @else {
              {{ 'Choose the amount to load onto the card with the number:' | trans:'cards/card-amount-picker-modal/card-number.Label' }}
            }
          </p>
          <p class="text-xl font-bold c-text-primary">
            <strong>{{ card.cardNr }}</strong>
          </p>
          @if (isWithdraw) {
            <p class="text-md m-t-8">
              {{ 'Aktuelles Guthaben:' | trans:'cards/card-amount-picker-modal/current-balance.Label' }} <strong>{{ card.currentBalance | numberToCurrency }} {{ languageConfig.currency.short }}</strong>
            </p>
          }
        </div>
      }

      <app-content-editable-input (valueChange)="amountValue = $event" />

      <div class="d-flex justify-content-flex-end m-t-auto p-t-4">
        <div class="width-fit-content p-4 base-border-radius c-bg-blue-200 p3 text-right">
          {{ data.minLoadAmount | numberToCurrency }} {{ languageConfig.currency.short }} - {{ data.maxLoadAmount | numberToCurrency }} {{ languageConfig.currency.short }}

          @if (data?.incrementAmount && !isWithdraw) {
            <div class="m-t-2 text-sm">
              {{ 'Staffeliung:'| trans:'cards/card-amount-picker-modal/increment-amount.Label' }} {{ data.incrementAmount | numberToCurrency }} {{ languageConfig.currency.short }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="m-t-24">
      <app-content-box theme="gray">
        <app-keyboard
          [isSimple]="false"
          (clear)="handleKeyboardClear()"
          (deleteBack)="handleKeyboardDeleteBack()"
          (keyClick)="handleKeyboardKeyClick($event)"
        />
      </app-content-box>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        #btn1
        class="button button--md button--primary-ghost text-uppercase"
        (click)="removeItemFromCart(btn1)"
      >
        {{ 'Cancel'| trans:'cards/card-amount-picker-modal/cancel.Button' }}
      </button>
      <button
        #btn2
        class="button button--md button--primary text-uppercase"
        [disabled]="isConfirmDisabled"
        (click)="addCardToCart(btn2)"
      >
        {{ 'Confirm'| trans:'cards/card-amount-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
